/* eslint-disable react-hooks/exhaustive-deps */
import { Segment } from 'semantic-ui-react';
import '../App.css';
import { useDispatch } from 'react-redux';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { useEffect } from 'react';

// eslint-disable-next-line no-empty-pattern
const FOIPage = ({ }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Object Identifier"));
    }, []);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            <h2>The FEvIR Object Identifier (FOI) is a globally unique persistent digital object identifier for a digital object that exists as a FHIR Resource.</h2>
            <div style={{ "textAlign": "left" }}>
                <p>The FEvIR Object Identifier (FOI) is a globally unique persistent digital object identifier for FHIR Resources accessible through the FEvIR Platform. The FEvIR Platform is a platform to support creation, viewing, notification, and interaction for computable expression of scientific knowledge. The FEvIR Platform is used to facilitate many projects, including the HL7 EBMonFHIR project and the Evidence Based Medicine on FHIR Implementation Guide. The FOI is an accession ID for database entries on the FEvIR Platform.</p>
            </div>
        </Segment>
    </div>
};

export default FOIPage;